import { useSelector } from "react-redux";
import { UserAppSettings } from "../api/fetchUserAppSettings/types";
import { selectUserAppSettings } from "../modules/hub/features/UserAppSettings/selectors/userAppSettingsSelectors";

const permissionsService = () => {
  const userAppSettings: UserAppSettings | null = useSelector(
    selectUserAppSettings,
  );

  const hasPermission = (permission: string): boolean => {
    if (!userAppSettings || !userAppSettings.permissions) {
      return false;
    }
    return userAppSettings.permissions.includes(permission);
  };

  const hasApplicationAccess = (applicationName: string): boolean => {
    if (!userAppSettings || !userAppSettings.applicationAccess) {
      return false;
    }
    return userAppSettings.applicationAccess.includes(applicationName);
  };

  const hasRole = (role: string): boolean => {
    if (!userAppSettings || !userAppSettings.roleName) {
      return false;
    }

    // Trim whitespace from both values to handle potential formatting issues
    const userRole = userAppSettings.roleName.trim();
    const requiredRole = role.trim();

    return userRole === requiredRole;
  };

  const hasCertainPathCompany = () => {
    if (!userAppSettings) return false;
    return userAppSettings.isCertainPathCompany;
  };

  return {
    hasPermission,
    hasApplicationAccess,
    hasRole,
    hasCertainPathCompany,
  };
};

export default permissionsService;
